import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { FullPageLoading } from './FullPageLoading';

interface ProtectedRouteProps {
  isAuthenticated: boolean;
  isLoading: boolean;
  emailVerified: boolean;
  authError: string | null;
  /** Título da tela de erro; ausente = falha de conexão. */
  authErrorTitulo?: string | null;
  onLogout: () => void;
  children: ReactNode;
}

export function ProtectedRoute({ isAuthenticated, isLoading, emailVerified, authError, authErrorTitulo, onLogout, children }: ProtectedRouteProps) {
  const location = useLocation();

  if (isLoading) {
    return <FullPageLoading />;
  }

  if (authError) {
    return (
      <div style={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--color-bg-dark)',
        padding: 24,
      }}>
        <div style={{
          maxWidth: 480,
          textAlign: 'center',
          padding: 32,
          borderRadius: 12,
          backgroundColor: 'var(--color-bg-paper)',
          border: '1px solid var(--color-divider)',
        }}>
          <div style={{
            fontSize: 48,
            marginBottom: 16,
          }}>!</div>
          <h1 style={{
            fontSize: 20,
            fontWeight: 600,
            color: 'var(--color-text-primary)',
            margin: '0 0 8px 0',
          }}>
            {authErrorTitulo ?? 'Erro ao conectar ao servidor'}
          </h1>
          <p style={{
            fontSize: 14,
            color: 'var(--color-text-secondary)',
            margin: '0 0 24px 0',
            lineHeight: 1.6,
          }}>
            {authError}
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 24px',
                backgroundColor: 'var(--color-primary)',
                color: 'white',
                border: 'none',
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              Tentar novamente
            </button>
            <button
              onClick={onLogout}
              style={{
                padding: '10px 24px',
                backgroundColor: 'transparent',
                color: 'var(--color-text-secondary)',
                border: '1px solid var(--color-divider)',
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              Encerrar sessão
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!emailVerified) {
    return <Navigate to="/verificar-email" replace />;
  }

  return <>{children}</>;
}
